(() => {
  const root = window.MudjugConfig?.root || window.Shopify?.routes?.root_url || '/';
  const cartUrl = (path) => `${root}${path}`;
  const moneyFormat = window.MudjugConfig?.moneyFormat || '{{amount}}';
  const currency = window.MudjugConfig?.currency || 'USD';
  const state = { cart: null, opener: null, busy: false };
  const drawer = document.querySelector('[data-cart-drawer]');
  const panel = document.querySelector('[data-cart-panel]');
  const toastRegion = document.querySelector('[data-toast-region]');
  const siteHeader = document.querySelector('[data-site-header]');
  if (siteHeader && 'ResizeObserver' in window) {
    const updateStickyHeaderHeight = () => document.documentElement.style.setProperty('--mudjug-sticky-header-height', `${siteHeader.getBoundingClientRect().height}px`);
    updateStickyHeaderHeight();
    new ResizeObserver(updateStickyHeaderHeight).observe(siteHeader);
  }
  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    try {
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || currency }).format(amount);
      return money;
    } catch (_) {
      return (moneyFormat || '{{amount}}').replace(/\{\{\s*amount\s*\}\}/, amount.toFixed(2));
    }
  };
  const request = async (path, options = {}) => {
    const response = await fetch(cartUrl(path), { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }), ...options.headers } });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  };
  const create = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const showToast = (message) => {
    if (!toastRegion) return;
    const toast = create('div', 'toast', message);
    toastRegion.append(toast);
    window.setTimeout(() => toast.remove(), 3200);
  };
  const setBusy = (button, busy) => {
    if (!button) return;
    button.disabled = busy;
    if (busy) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
  };
  const renderCart = (cart) => {
    state.cart = cart;
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
    document.querySelectorAll('[data-cart-open]').forEach((node) => { node.setAttribute('aria-label', `Open kit, ${cart.item_count} items`); });
    document.querySelectorAll('[data-cart-heading-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
    document.querySelectorAll('[data-cart-subtotal]').forEach((node) => { node.textContent = formatMoney(cart.total_price); });
    document.querySelectorAll('[data-cart-discount-row]').forEach((row) => {
      const discount = Math.max(0, Number(cart.total_discount || 0));
      row.hidden = discount <= 0;
      const amount = row.querySelector('[data-cart-discount-amount]');
      if (amount) amount.textContent = `−${formatMoney(discount)}`;
    });
    const body = document.querySelector('[data-cart-body]');
    if (body) {
      body.replaceChildren();
      if (!cart.items.length) {
        const empty = create('div', 'empty-state');
        empty.append(create('h3', '', 'Your kit is waiting.'), create('p', 'fine-print', 'Explore the lineup and add your everyday pick.'), Object.assign(create('a', 'button', 'Shop Mudjugs'), { href: root }));
        body.append(empty);
      } else {
        cart.items.forEach((item) => {
          const line = create('article', 'cart-line');
          const image = create('img', 'cart-line__image');
          image.src = item.featured_image?.url || item.image || '';
          image.alt = item.featured_image?.alt || item.product_title || item.title;
          image.loading = 'lazy';
          const meta = create('div');
          const title = create('a', '', item.product_title || item.title);
          title.href = item.url || '#';
          const variant = create('div', 'cart-line__meta', item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
          const properties = item.properties || {};
          const giftLine = Object.keys(properties).some((key) => key.toLowerCase().includes('mudjug_reward_candidate'));
          if (giftLine) variant.textContent = `${variant.textContent ? `${variant.textContent} · ` : ''}`;
          const actions = create('div', 'cart-line__actions');
          const decrease = create('button', '', '−'); decrease.type = 'button'; decrease.setAttribute('aria-label', `Decrease ${item.product_title || item.title} quantity`); decrease.dataset.cartChange = ''; decrease.dataset.key = item.key; decrease.dataset.quantity = String(Math.max(0, item.quantity - 1));
          const quantity = create('span', '', String(item.quantity));
          const increase = create('button', '', '+'); increase.type = 'button'; increase.setAttribute('aria-label', `Increase ${item.product_title || item.title} quantity`); increase.dataset.cartChange = ''; increase.dataset.key = item.key; increase.dataset.quantity = String(item.quantity + 1);
          const remove = create('button', '', 'Remove'); remove.type = 'button'; remove.dataset.cartChange = ''; remove.dataset.key = item.key; remove.dataset.quantity = '0';
          actions.append(decrease, quantity, increase, remove);
          meta.append(title, variant, actions);
          const lineTotal = create('strong', '', formatMoney(item.final_line_price));
          line.append(image, meta, lineTotal);
          body.append(line);
        });

      }
    }
    const cartPageBody = document.querySelector('[data-cart-page-body]');
    if (cartPageBody) {
      cartPageBody.replaceChildren();
      if (!cart.items.length) {
        const empty = create('div', 'empty-state');
        empty.append(create('h2', 'section-heading', 'Your kit is empty.'), create('p', 'fine-print', 'Start with the format that fits your day.'), Object.assign(create('a', 'button', 'Shop Mudjugs'), { href: root }));
        cartPageBody.append(empty);
      } else {
        cart.items.forEach((item) => {
          const line = create('article', 'cart-line');
          const image = create('img', 'cart-line__image'); image.src = item.featured_image?.url || item.image || ''; image.alt = item.featured_image?.alt || item.product_title || item.title; image.loading = 'lazy';
          const details = create('div'); const title = create('a', 'product-card__title', item.product_title || item.title); title.href = item.url || '#';
          const variant = create('p', 'cart-line__meta', item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
          const controls = create('div', 'cart-line__actions');
          const minus = create('button', '', '−'); minus.type = 'button'; minus.dataset.cartChange = ''; minus.dataset.key = item.key; minus.dataset.quantity = String(Math.max(0, item.quantity - 1)); minus.setAttribute('aria-label', `Decrease ${item.product_title || item.title} quantity`);
          const amount = create('span', '', String(item.quantity));
          const plus = create('button', '', '+'); plus.type = 'button'; plus.dataset.cartChange = ''; plus.dataset.key = item.key; plus.dataset.quantity = String(item.quantity + 1); plus.setAttribute('aria-label', `Increase ${item.product_title || item.title} quantity`);
          const remove = create('button', '', 'Remove'); remove.type = 'button'; remove.dataset.cartChange = ''; remove.dataset.key = item.key; remove.dataset.quantity = '0';
          controls.append(minus, amount, plus, remove); details.append(title, variant, controls);
          line.append(image, details, create('strong', '', formatMoney(item.final_line_price))); cartPageBody.append(line);
        });
        if (cart.total_discount > 0) {
          const discount = create('div', 'cart-drawer__subtotal cart-drawer__discount');
          discount.append(create('span', '', 'Discounts applied'), create('strong', '', `−${formatMoney(cart.total_discount)}`));
          cartPageBody.append(discount);
        }
        const total = create('div', 'cart-drawer__subtotal'); total.append(create('span', '', 'Subtotal'), create('strong', '', formatMoney(cart.total_price))); cartPageBody.append(total);
        // Dedicated reward slots persist across cart refreshes and are populated by the shared gift UI.
        const rewards = create('section', 'mj-cart-page-rewards');
        rewards.setAttribute('aria-label', 'Your free Field Kit gifts');
        const lidSlot = create('div', 'mj-lid-reward-slot'); lidSlot.dataset.mjLidSlot = '';
        const stealthSlot = create('div', 'mj-lid-reward-slot'); stealthSlot.dataset.mjStealthSlot = '';
        rewards.append(lidSlot, stealthSlot);
        cartPageBody.append(rewards);
        const note = create('p', 'fine-print', 'Discounts and shipping are calculated by Shopify at checkout.');
        const checkout = create('a', 'button', 'Secure checkout →'); checkout.href = "/checkout";
        cartPageBody.append(note, checkout);
      }
    }
    renderBundle(cart);
    document.dispatchEvent(new CustomEvent('mudjug:cart-updated', { detail: cart }));
  };
  const refreshCart = async () => renderCart(await request('cart.js', { headers: { 'Content-Type': 'application/json' } }));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCart().catch(() => {}); });
  // Reward picker and other cart integrations request an immediate full drawer repaint.
  document.addEventListener('cart:refresh', () => { refreshCart().catch((error) => showToast(error.message)); });
  document.addEventListener('cart:updated', () => { refreshCart().catch((error) => showToast(error.message)); });
  const openDrawer = () => {
    if (!drawer) return;
    state.opener = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    panel?.focus();
    refreshCart().catch((error) => showToast(error.message));
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    state.opener?.focus?.();
  };
  const addToCart = async (formOrItem, button, options = {}) => {
    setBusy(button, true);
    try {
      let body;
      if (formOrItem instanceof HTMLFormElement) body = new FormData(formOrItem);
      else body = JSON.stringify(formOrItem);
      await request('cart/add.js', { method: 'POST', body });
      await refreshCart();
      const bundleError = document.querySelector('[data-bundle-error]');
      if (options.bundle && bundleError) bundleError.hidden = true;
      if (options.openCart !== false) openDrawer();
    } catch (error) {
      if (options.bundle) showBundleError(error.message);
      showToast(error.message);
    } finally {
      setBusy(button, false);
      if (options.bundle) renderBundle();
    }
  };
  const updateLine = async (key, quantity, button) => {
    setBusy(button, true);
    try {
      renderCart(await request('cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: Number(quantity) }) }));
      return true;
    } catch (error) {
      showToast(error.message);
      return false;
    } finally { setBusy(button, false); }
  };
  const bundleProducts = () => [...document.querySelectorAll('[data-bundle-product]')];
  const renderBundle = (cart = state.cart) => {
    const builder = document.querySelector('[data-bundle-builder]');
    if (!builder || !cart) return;
    const eligible = state.bundleEligible || new Set(bundleProducts().map((node) => String(node.dataset.productId)));
    const counts = new Map();
    const cartItems = cart.items.filter((item) => {
      const properties = item.properties || {};
      const isReward = Object.keys(properties).some((key) => key.toLowerCase().includes('mudjug_reward_candidate'));
      const isBundleProduct = eligible.has(String(item.product_id));
      if (!isReward && isBundleProduct) {
        counts.set(String(item.product_id), (counts.get(String(item.product_id)) || 0) + item.quantity);
        return true;
      }
      return false;
    });
    const quantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
    // Match the slide cart exactly: Shopify's final cart total already includes
    // all applied automatic/code discounts, including accessories in the cart.
    const subtotal = Number(cart.total_price || 0);
    const discount = Math.max(0, Number(cart.total_discount || 0));
    const visibleSlots = Math.max(4, quantity);
    builder.querySelectorAll('[data-bundle-product]').forEach((card) => {
      const count = counts.get(String(card.dataset.productId)) || 0;
      const target = card.querySelector('[data-bundle-quantity]');
      if (target) target.textContent = `In your kit: ${count}`;
      const add = card.querySelector('[data-bundle-add]');
      const variant = card.querySelector('[data-bundle-variant]');
      const selected = variant?.selectedOptions?.[0] || variant;
      const available = selected?.dataset.available === 'true';
      const label = card.querySelector('[data-bundle-add-label]');
      if (add) {
        add.disabled = !available;
        if (label) label.textContent = available ? builder.dataset.addLabel || 'Add to kit' : builder.dataset.soldOutLabel || 'Sold out';
      }
    });
    builder.querySelectorAll('[data-bundle-qty]').forEach((el) => { el.textContent = quantity; });
    builder.querySelectorAll('[data-bundle-total], [data-bundle-total-desktop]').forEach((el) => { el.textContent = formatMoney(subtotal); });
    builder.querySelectorAll('[data-bundle-discount-row]').forEach((row) => {
      row.hidden = discount <= 0;
      const amount = row.querySelector('[data-bundle-discount-amount]');
      if (amount) amount.textContent = `−${formatMoney(discount)}`;
    });
    const emptyMessage = builder.querySelector('[data-bundle-empty]');
    if (emptyMessage) emptyMessage.hidden = quantity > 0;
    const checkout = builder.querySelector('[data-bundle-checkout]');
    if (checkout) checkout.setAttribute('aria-disabled', String(quantity === 0));
    const slots = builder.querySelector('[data-bundle-slots]');
    const slotsCount = builder.querySelector('[data-bundle-slots-count]');
    const selectedUnits = cartItems.flatMap((item) => Array.from({ length: item.quantity }, () => item));
    if (slots) {
      slots.replaceChildren();
      if (slotsCount) slotsCount.textContent = String(quantity).padStart(2, '0');
      Array.from({ length: visibleSlots }, (_, index) => {
        const item = selectedUnits[index];
        const number = String(index + 1).padStart(2, '0');
        if (!item) {
          const empty = create('div', 'bundle-slot is-empty');
          empty.setAttribute('role', 'listitem');
          empty.setAttribute('aria-label', `Empty bundle slot ${number}`);
          empty.append(create('span', 'bundle-slot__number', number), create('span', 'bundle-slot__empty-label', 'Open slot'));
          slots.append(empty);
          return;
        }
        const title = item.product_title || item.title;
        const slot = create('div', 'bundle-slot is-occupied');
        slot.setAttribute('role', 'listitem');
        slot.setAttribute('aria-label', `${title}, slot ${number}`);
        const media = create('span', 'bundle-slot__media');
        const imageUrl = item.featured_image?.url || item.image;
        if (imageUrl) {
          const image = create('img');
          image.src = imageUrl;
          image.alt = title;
          image.loading = 'lazy';
          media.append(image);
        }
        const remove = create('button', 'bundle-slot__remove', '×');
        remove.type = 'button';
        remove.dataset.bundleRemove = '';
        remove.dataset.key = item.key;
        remove.dataset.quantity = String(Math.max(0, item.quantity - 1));
        remove.setAttribute('aria-label', `Remove one ${title} from your field kit`);
        slot.append(media, remove);
        slots.append(slot);
      });
    }
    // Update the paid-item badge directly from the cart-derived bundle quantity.
    builder.querySelectorAll('[data-bundle-progress-count]').forEach((el) => {
      el.textContent = String(quantity);
    });
    // Bundle-page horizontal tracker uses the exact same thresholds and cart count.
    const stage = document.querySelector('[data-bundle-stage]');
    if (stage) {
      const tiers = [...stage.querySelectorAll('[data-bundle-stage-tier]')];
      const lastThreshold = Math.max(1, ...tiers.map(el => Number(el.dataset.threshold || 1)));
      const fill = stage.querySelector('[data-bundle-stage-fill]');
      const track = stage.querySelector('[data-bundle-stage-track]');
      if (fill) fill.style.width = `${Math.min(100, (quantity / lastThreshold) * 100)}%`;
      if (track) {
        track.setAttribute('aria-valuemax', String(lastThreshold));
        track.setAttribute('aria-valuenow', String(Math.min(quantity, lastThreshold)));
        track.setAttribute('aria-valuetext', `${quantity} Mudjugs selected`);
      }
      const progressMessage = stage.querySelector('[data-bundle-progress-message]');
      if (progressMessage) {
        progressMessage.textContent = quantity < 2 ? `Add ${2 - quantity} Mudjug${2 - quantity === 1 ? '' : 's'} for a FREE Lid` :
          quantity < 3 ? 'Add 1 Mudjug for FREE Basic Stealth' :
          quantity < 4 ? 'Add 1 Mudjug for FREE Shipping' :
          'ALL REWARDS UNLOCKED!';
      }
      tiers.forEach((tier) => {
        const threshold = Math.max(1, Number(tier.dataset.threshold || 1));
        const done = quantity >= threshold;
        const next = !done && !tiers.some(other => Number(other.dataset.threshold || 1) > quantity && Number(other.dataset.threshold || 1) < threshold);
        tier.classList.toggle('is-complete', done);
        tier.classList.toggle('is-next', next);
        const circle = tier.querySelector('[data-bundle-stage-circle]');
        if (circle) circle.textContent = done ? '✓' : String(threshold).padStart(2, '0');
      });
    }
    builder.querySelectorAll('[data-bundle-milestone]').forEach((milestone) => {
      const threshold = Math.max(1, Number(milestone.dataset.threshold || 1));
      const complete = quantity >= threshold;
      milestone.dataset.complete = String(complete);
      const status = milestone.querySelector('[data-bundle-milestone-status]');
      if (status) status.textContent = complete ? 'Complete' : `${threshold - quantity} to go`;
      const meter = milestone.querySelector('[data-bundle-milestone-meter]');
      if (meter) meter.style.width = `${Math.min(100, quantity / threshold * 100)}%`;
    });
  };
  const showBundleError = (message) => {
    const error = document.querySelector('[data-bundle-error]');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
  };
  const openGiftDialog = () => {
    const dialog = document.querySelector('[data-gift-dialog]');
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  };
  const closeGiftDialog = () => document.querySelector('[data-gift-dialog]')?.close();
  const getQuickViewDialog = () => {
    let dialog = document.querySelector('[data-quick-view-dialog]');
    if (!dialog) {
      dialog = create('dialog', 'modal'); dialog.dataset.quickViewDialog = '';
      const content = create('div', 'modal__panel'); content.dataset.quickViewPanel = '';
      dialog.append(content); document.body.append(dialog);
      // Freeze the page while a modal is open, including on iOS Safari.
      // Restore the exact previous scroll position when it closes.
      let savedScrollY = 0;
      let savedBodyStyle = null;
      let savedHtmlOverflow = '';
      dialog.addEventListener('close', () => {
        if (savedBodyStyle === null) return;
        const previous = savedBodyStyle;
        savedBodyStyle = null;
        document.body.style.position = previous.position;
        document.body.style.top = previous.top;
        document.body.style.left = previous.left;
        document.body.style.right = previous.right;
        document.body.style.width = previous.width;
        document.body.style.overflow = previous.overflow;
        document.documentElement.style.overflow = savedHtmlOverflow;
        window.scrollTo(0, savedScrollY);
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('mudjug-lock-scroll', () => {
        if (savedBodyStyle !== null) return;
        savedScrollY = window.scrollY;
        savedHtmlOverflow = document.documentElement.style.overflow;
        savedBodyStyle = {
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left,
          right: document.body.style.right,
          width: document.body.style.width,
          overflow: document.body.style.overflow
        };
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${savedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      });

    }
    return dialog;
  };
  const openQuickView = (id) => {
    const source = document.querySelector(`[data-quick-view-content="${CSS.escape(id)}"]`);
    const card = source?.closest('[data-bundle-product]');
    if (!source || !card) return;
    const dialog = getQuickViewDialog();
    const content = dialog.querySelector('[data-quick-view-panel]');
    content.className = 'modal__panel mudjug-product-quick-view';
    content.replaceChildren();
    const heading = create('div', 'mudjug-product-quick-view__heading');
    const eyebrow = create('p', 'eyebrow', 'FIELD KIT / PRODUCT DETAILS');
    const close = create('button', 'mudjug-product-quick-view__close', '×');
    close.type = 'button'; close.setAttribute('aria-label', 'Close product details');
    close.addEventListener('click', () => dialog.close());
    heading.append(eyebrow, close);
    const grid = create('div', 'mudjug-product-quick-view__grid');
    const gallery = create('div', 'mudjug-product-quick-view__gallery');
    const media = create('div', 'mudjug-product-quick-view__media');
    const mainImage = create('img');
    mainImage.alt = source.querySelector('h3')?.textContent || 'Mudjug product';
    const fallbackImage = card.querySelector('.bundle-product__media img');
    const images = [...source.querySelectorAll('[data-quick-image]')];
    const setMainImage = (url, alt) => { if (url) { mainImage.src = url; mainImage.alt = alt || mainImage.alt; } };
    if (images.length) setMainImage(images[0].dataset.quickImage, images[0].dataset.quickAlt);
    else if (fallbackImage) setMainImage(fallbackImage.currentSrc || fallbackImage.src, fallbackImage.alt);
    media.append(mainImage); gallery.append(media);
    if (images.length > 1) {
      const thumbs = create('div', 'mudjug-product-quick-view__thumbs');
      images.forEach((image, index) => {
        const thumb = create('button', 'mudjug-product-quick-view__thumb');
        thumb.type = 'button'; thumb.setAttribute('aria-label', `View product image ${index + 1}`);
        const img = create('img'); img.src = image.dataset.quickThumb || image.dataset.quickImage;
        img.alt = image.dataset.quickAlt || ''; thumb.append(img);
        thumb.addEventListener('click', () => setMainImage(image.dataset.quickImage, image.dataset.quickAlt));
        thumbs.append(thumb);
      }); gallery.append(thumbs);
    }
    const details = create('div', 'mudjug-product-quick-view__details');
    const vendor = create('p', 'eyebrow mudjug-product-quick-view__vendor', source.dataset.vendor || 'MUDJUG');
    const title = create('h2', 'mudjug-product-quick-view__title', source.querySelector('h3')?.textContent || 'Product details');
    title.id = 'mudjug-quick-view-title'; dialog.setAttribute('aria-labelledby', title.id);
    const price = create('p', 'mudjug-product-quick-view__price', card.querySelector('[data-bundle-price]')?.textContent || '');
    const copy = create('div', 'rte mudjug-product-quick-view__description');
    copy.innerHTML = source.querySelector('[data-quick-description]')?.innerHTML || '';
    const originalVariant = card.querySelector('[data-bundle-variant]');
    let variantControl;
    details.append(vendor, title, price, copy);
    const realOptions = originalVariant?.tagName === 'SELECT' && [...originalVariant.options].some(o => o.textContent.trim() !== 'Default Title');
    if (realOptions) {
      const label = create('label', 'mudjug-product-quick-view__label', 'Choose an option');
      variantControl = originalVariant.cloneNode(true);
      variantControl.removeAttribute('id'); variantControl.removeAttribute('data-bundle-variant');
      variantControl.className = 'mudjug-product-quick-view__variant';
      variantControl.addEventListener('change', () => {
        const option = variantControl.selectedOptions[0];
        if (option) {
          price.textContent = formatMoney(option.dataset.price);
          if (option.dataset.image) setMainImage(option.dataset.image);
          add.disabled = option.dataset.available !== 'true';
          add.textContent = add.disabled ? 'SOLD OUT' : 'ADD TO KIT  →';
        }
      });
      details.append(label, variantControl);
    }
    const quantityLabel = create('label', 'mudjug-product-quick-view__label', 'Quantity');
    const quantityControl = create('div', 'mudjug-product-quick-view__quantity');
    const minus = create('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease quantity');
    const qty = create('input'); qty.type = 'number'; qty.min = '1'; qty.value = '1'; qty.inputMode = 'numeric'; qty.setAttribute('aria-label', 'Quantity');
    const plus = create('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase quantity');
    minus.addEventListener('click', () => { qty.value = String(Math.max(1, Number(qty.value || 1) - 1)); });
    plus.addEventListener('click', () => { qty.value = String(Number(qty.value || 1) + 1); });
    quantityControl.append(minus, qty, plus);
    details.append(quantityLabel, quantityControl);
    const error = create('p', 'mudjug-product-quick-view__error'); error.setAttribute('role', 'alert'); error.hidden = true;
    const add = create('button', 'mudjug-product-quick-view__add', 'ADD TO KIT  →'); add.type = 'button';
    const getVariant = () => variantControl?.value || originalVariant?.value;
    add.disabled = variantControl ? variantControl.selectedOptions[0]?.dataset.available !== 'true' : originalVariant?.dataset.available !== 'true';
    if (add.disabled) add.textContent = 'SOLD OUT';
    add.addEventListener('click', async () => {
      const builder = card.closest('[data-bundle-builder]');
      const count = Number(builder?.querySelector('[data-bundle-qty]')?.textContent || 0);
      const amount = Number(qty.value);
      if (!Number.isSafeInteger(amount) || amount < 1) { error.textContent = 'Choose a valid quantity.'; error.hidden = false; return; }
      if (!getVariant()) return;
      setBusy(add, true); error.hidden = true;
      try {
        await request('cart/add.js', { method: 'POST', body: JSON.stringify({ id: getVariant(), quantity: amount, properties: { _mudjug_field_kit: 'true' } }) });
        await refreshCart(); dialog.close(); showToast('Added to your field kit.');
      } catch (err) { error.textContent = err.message; error.hidden = false; }
      finally { setBusy(add, false); }
    });
    details.append(error, add);
    const finePrint = create('p', 'mudjug-product-quick-view__fine-print', 'Shipping and applicable discounts are calculated by Shopify at checkout.');
    details.append(finePrint);
    const accordion = (label, html) => {
      const el = create('details', 'mudjug-product-quick-view__accordion');
      const summary = create('summary', '', label);
      const body = create('div', 'rte mudjug-product-quick-view__accordion-content');
      body.innerHTML = html;
      el.append(summary, body); return el;
    };
    details.append(accordion('PRODUCT DETAILS', source.querySelector('[data-quick-description]')?.innerHTML || ''),
      accordion('SHIPPING & RETURNS', 'Shipping options and policies are shown at checkout. Review the store policies for details.'));
    const collections = create('a', 'mudjug-product-quick-view__collections', '← EXPLORE COLLECTIONS');
    collections.href = '/collections'; details.append(collections);
    grid.append(gallery, details); content.append(heading, grid);
    if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    dialog.dispatchEvent(new Event('mudjug-lock-scroll'));
    // Avoid the persistent blue tap-focus ring on iPhone; keyboard focus stays available.
    close.focus({ preventScroll: true });
    if (window.matchMedia('(pointer: coarse)').matches) close.blur();
  };
  const openBundleSlotQuickView = (key) => {
    const item = state.cart?.items.find((cartItem) => cartItem.key === key);
    if (!item) return;
    const dialog = getQuickViewDialog();
    const content = dialog.querySelector('[data-quick-view-panel]');
    content.className = 'modal__panel bundle-slot-quick-view';
    content.replaceChildren();
    const heading = create('div', 'bundle-slot-quick-view__heading');
    const title = create('h2', 'section-heading', item.product_title || item.title);
    title.id = 'bundle-slot-quick-view-title';
    dialog.setAttribute('aria-labelledby', title.id);
    const close = create('button', 'icon-button', 'Close ×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close product quick view');
    close.addEventListener('click', () => dialog.close());
    heading.append(title, close);
    const imageUrl = item.featured_image?.url || item.image;
    const media = create('div', 'bundle-slot-quick-view__media');
    if (imageUrl) {
      const image = create('img');
      image.src = imageUrl;
      image.alt = item.featured_image?.alt || item.product_title || item.title;
      image.loading = 'lazy';
      media.append(image);
    }
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'FIELD STANDARD';
    const variantText = create('p', 'bundle-slot-quick-view__variant', variant);
    const price = create('p', 'bundle-slot-quick-view__price', formatMoney(item.price));
    const controls = create('div', 'bundle-slot-quick-view__controls');
    const quantityLabel = create('span', 'bundle-slot-quick-view__quantity-label', 'Quantity in your kit');
    const stepper = create('div', 'bundle-slot-quick-view__stepper');
    const decrease = create('button', 'button button--outline', '−');
    decrease.type = 'button';
    decrease.disabled = item.quantity <= 1;
    decrease.setAttribute('aria-label', `Decrease ${item.product_title || item.title} quantity`);
    decrease.addEventListener('click', async () => {
      if (await updateLine(item.key, item.quantity - 1, decrease)) openBundleSlotQuickView(item.key);
    });
    const quantity = create('span', 'bundle-slot-quick-view__quantity', String(item.quantity));
    quantity.setAttribute('aria-live', 'polite');
    const increase = create('button', 'button button--outline', '+');
    increase.type = 'button';
    increase.setAttribute('aria-label', `Increase ${item.product_title || item.title} quantity`);
    increase.addEventListener('click', async () => {
      if (await updateLine(item.key, item.quantity + 1, increase)) openBundleSlotQuickView(item.key);
    });
    stepper.append(decrease, quantity, increase);
    controls.append(quantityLabel, stepper);
    const remove = create('button', 'button button--outline bundle-slot-quick-view__remove', 'Remove product from kit');
    remove.type = 'button';
    remove.addEventListener('click', async () => {
      if (await updateLine(item.key, 0, remove)) dialog.close();
    });
    content.append(heading, media, variantText, price, controls, remove);
    if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
  };
  const updateVariant = (select) => {
    const option = select.selectedOptions[0];
    const rootNode = select.closest('[data-product-root]');
    if (!option || !rootNode) return;
    const price = Number(option.dataset.price || 0);
    const compare = Number(option.dataset.compare || 0);
    const priceNode = rootNode.querySelector('[data-product-price]');
    if (priceNode) { priceNode.textContent = formatMoney(price); if (compare > price) { const old = create('span', 'price--compare', formatMoney(compare)); priceNode.append(old); } }
    const submits = rootNode.querySelectorAll('[data-product-submit]');
    const available = option.dataset.available === 'true';
    submits.forEach((submit) => { submit.disabled = !available; submit.textContent = available ? 'Add to kit' : 'Sold out'; });
    const image = option.dataset.image;
    const main = rootNode.querySelector('[data-gallery-main]');
    if (image && main) { const img = main.querySelector('img') || create('img'); img.src = image; img.alt = rootNode.querySelector('h1')?.textContent || ''; img.loading = 'eager'; main.replaceChildren(img); }
  };
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]'); if (open) { event.preventDefault(); openDrawer(); return; }
    if (event.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const bundleRemove = event.target.closest('[data-bundle-remove]'); if (bundleRemove) { updateLine(bundleRemove.dataset.key, bundleRemove.dataset.quantity, bundleRemove); return; }
    const change = event.target.closest('[data-cart-change]'); if (change) { updateLine(change.dataset.key, change.dataset.quantity, change); return; }
    const add = event.target.closest('[data-bundle-add]'); if (add) { const card = add.closest('[data-bundle-product]'); const select = card?.querySelector('[data-bundle-variant]'); const builder = add.closest('[data-bundle-builder]'); if (select?.value) addToCart({ id: select.value, quantity: 1, properties: { _mudjug_field_kit: 'true' } }, add, { openCart: false, bundle: true }); else if (add.dataset.variantId) addToCart({ id: add.dataset.variantId, quantity: 1, properties: { _mudjug_field_kit: 'true' } }, add, { openCart: false, bundle: true }); return; }
    const checkout = event.target.closest('[data-bundle-checkout][aria-disabled="true"]'); if (checkout) { event.preventDefault(); showBundleError('Add at least one product to your field kit before continuing.'); return; }
    const gift = event.target.closest('[data-add-gift]'); if (gift) { const unlockedGiftReward = [...document.querySelectorAll('[data-reward]')].some((reward) => reward.dataset.rewardType === 'gift' && reward.dataset.unlocked === 'true'); if (!unlockedGiftReward) { showToast('Add eligible products to unlock this reward.'); closeGiftDialog(); return; } const card = gift.closest('.product-card'); const select = card?.querySelector('[data-gift-variant]'); const id = select?.value || gift.dataset.variantId; addToCart({ id, quantity: 1, properties: { _mudjug_reward_candidate: 'true' } }, gift); closeGiftDialog(); return; }
    const giftOpen = event.target.closest('[data-open-gift]'); if (giftOpen && !giftOpen.disabled) { openGiftDialog(); return; }
    if (event.target.closest('[data-gift-close]')) { closeGiftDialog(); return; }
    const bundleSlot = event.target.closest('[data-bundle-slot]'); if (bundleSlot) { openBundleSlotQuickView(bundleSlot.dataset.key); return; }
    const quick = event.target.closest('[data-quick-view]'); if (quick) { openQuickView(quick.dataset.quickView); return; }
    const filter = event.target.closest('[data-bundle-filter]'); if (filter) { const value = filter.dataset.bundleFilter; const builder = filter.closest('[data-bundle-builder]'); builder?.querySelectorAll('[data-bundle-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button === filter))); builder?.querySelectorAll('[data-bundle-product]').forEach((card) => { card.hidden = value !== 'all' && card.dataset.category !== value; }); return; }
    const mobileMenuClose = event.target.closest('[data-mobile-menu-close]');
    if (mobileMenuClose) {
      const toggle = document.querySelector('[data-mobile-menu-toggle]');
      const nav = document.querySelector('[data-mobile-nav]');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.setAttribute('aria-label', 'Open navigation');
      nav?.setAttribute('aria-hidden', 'true');
      toggle?.focus();
      return;
    }
    const mobileNavLink = event.target.closest('[data-mobile-nav] a'); if (mobileNavLink) { const toggle = document.querySelector('[data-mobile-menu-toggle]'); const nav = document.querySelector('[data-mobile-nav]'); toggle?.setAttribute('aria-expanded', 'false'); toggle?.setAttribute('aria-label', 'Open navigation'); nav?.setAttribute('aria-hidden', 'true'); return; }
    const menu = event.target.closest('[data-mobile-menu-toggle]'); if (menu) { const nav = document.querySelector('[data-mobile-nav]'); const expanded = menu.getAttribute('aria-expanded') === 'true'; menu.setAttribute('aria-expanded', String(!expanded)); menu.setAttribute('aria-label', expanded ? 'Open navigation' : 'Close navigation'); nav?.setAttribute('aria-hidden', String(expanded)); if (!expanded) nav?.querySelector('a:not(.mobile-nav-brand)')?.focus(); return; }
    const summaryToggle = event.target.closest('[data-bundle-summary-toggle]'); if (summaryToggle) { const summary = summaryToggle.closest('[data-bundle-summary]'); const expanded = summary.classList.toggle('is-expanded'); summaryToggle.setAttribute('aria-expanded', String(expanded)); return; }
    const plus = event.target.closest('[data-quantity-plus]'); if (plus) { const input = plus.parentElement.querySelector('input'); input.value = Math.min(Number(input.max || 99), Number(input.value || 1) + 1); return; }
    const minus = event.target.closest('[data-quantity-minus]'); if (minus) { const input = minus.parentElement.querySelector('input'); input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1); return; }
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) {
      const gallery = thumb.closest('.product-gallery');
      const main = gallery?.querySelector('[data-gallery-main]');
      const image = main?.querySelector('img');
      const url = thumb.dataset.galleryThumb;
      if (image && url) {
        // Shopify image_tag emits srcset; remove it so the selected src actually displays.
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
        image.alt = thumb.querySelector('img')?.alt || image.alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(button => {
          const active = button === thumb;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }
    }
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-variant-select]')) updateVariant(event.target);
    if (event.target.matches('select[data-bundle-variant]')) { const card = event.target.closest('[data-bundle-product]'); const builder = card?.closest('[data-bundle-builder]'); const selected = event.target.selectedOptions[0]; const price = card?.querySelector('[data-bundle-price]'); const finish = card?.querySelector('[data-bundle-finish]'); const image = card?.querySelector('.bundle-product__media img'); const add = card?.querySelector('[data-bundle-add]'); const addLabel = card?.querySelector('[data-bundle-add-label]'); if (price && selected) price.textContent = formatMoney(selected.dataset.price); if (finish && selected?.dataset.title) finish.textContent = selected.dataset.title; if (image && selected?.dataset.image) image.src = selected.dataset.image; if (add) add.disabled = selected?.dataset.available !== 'true'; if (addLabel) addLabel.textContent = selected?.dataset.available === 'true' ? builder?.dataset.addLabel || 'Add to kit' : builder?.dataset.soldOutLabel || 'Sold out'; renderBundle(); }
    if (event.target.matches('[data-gift-variant]')) { const selected = event.target.selectedOptions[0]; const price = event.target.closest('.product-card')?.querySelector('[data-gift-price]'); if (price && selected) price.textContent = formatMoney(selected.dataset.price); }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form], [data-quick-add]');
    if (form) { event.preventDefault(); addToCart(form, event.submitter || form.querySelector('[type="submit"]')); }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') closeDrawer();
    const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    if (event.key === 'Escape' && mobileToggle?.getAttribute('aria-expanded') === 'true') { mobileToggle.setAttribute('aria-expanded', 'false'); mobileToggle.setAttribute('aria-label', 'Open navigation'); mobileNav?.setAttribute('aria-hidden', 'true'); mobileToggle.focus(); }
    if (event.key === 'Tab' && drawer?.getAttribute('aria-hidden') === 'false' && panel) {
      const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex="0"]')];
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('shopify:section:load', () => { refreshCart().catch(() => {}); });
  document.addEventListener('shopify:section:select', () => { refreshCart().catch(() => {}); });
  document.addEventListener('DOMContentLoaded', () => { refreshCart().catch((error) => { const body = document.querySelector('[data-cart-body]'); if (body) body.textContent = error.message; }); });
  refreshCart().catch(() => {});
})();
